<template>
  <span
    class="type-badge inline-block w-max truncate rounded-sm border border-black px-2 py-0.75 text-xs leading-[130%] md:text-sm lg:py-1.25 xl:leading-[143%] 2xl:py-1.5 2xl:text-[17px]/[21px]"
  >
    {{ text }}
  </span>
</template>

<script setup lang="ts">
interface Props {
  text: string
}

const props = defineProps<Props>()
</script>

<style scoped>
.type-badge {
  border-color: #000000 !important;
}
</style>
